import React from 'react';
import { formatCurrency } from '../../../../utils/format';

export function MarginRow({ label, value, sub, bold, valueColor, faint }: {
  label: string; value: number; sub?: string; bold?: boolean; valueColor?: string; faint?: boolean;
}) {
  const isNeg = value < 0;
  const color = valueColor ?? (faint ? 'var(--color-text-faint)' : 'var(--color-text)');
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '0.25rem 0', opacity: faint ? 0.7 : 1 }}>
      <div>
        <span style={{ fontSize: 'var(--text-sm)', color: faint ? 'var(--color-text-faint)' : 'var(--color-text-muted)', fontWeight: bold ? 600 : 400 }}>{label}</span>
        {sub && <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)', marginTop: '0.0625rem' }}>{sub}</p>}
      </div>
      {value !== 0 && (
        <span style={{ fontSize: 'var(--text-sm)', fontWeight: bold ? 700 : 500, color, whiteSpace: 'nowrap', marginLeft: '1rem' }}>
          {isNeg ? `−${formatCurrency(Math.abs(value))}` : formatCurrency(value)}
        </span>
      )}
    </div>
  );
}
